// URL Parameters and Tracking Codes
export const BRAND_BASE_URL = "https://drmartypets.com";
export const CDN_BASE_URL = "https://cdn.drmartypets.com";
export const CART_BASE_URL = "https://drmartypets.com";
export const BRIGHTCOVE_BASE_URL = "https://players.brightcove.net/6415896096001";


// External Service URLs
export const EXTERNAL_URLS = {
  PAYPAL_BUTTON: "https://cdn.drmartypets.com/images/paypalButton.jpg"
};

export const PARAM = "n";
export const OBTCR = "obtcr";
export const TBATCR = "tbatcr";
export const FBTCR = "fbtcr";
export const DBTCR = "dbtcr";
export const REVTCR = "revtcr";
export const ADV = "Advertorial";
export const ADVERT = "Advertisement";
export const OPT = 'opt';
export const OBNATCR = 'obnatcr';
export const MSNTCR = 'msntcr';
export const OB = 'ob';
export const AOL = 'aol';
export const AOLTCR = 'aoltcr';
export const GDN = 'gdn';
export const GDNTCR = 'gdntcr';
export const AYAHTCR = 'ayahtcr';
export const AYAHC = 'ayahc';
export const AYAHLG = 'ayahlg';
export const ATBATCR = 'atbatcr';
export const VMXGUN = 'vmxgun';
export const RMGEM = 'rm-gem';